Ext.define('SA.view.pvt.FilteringButton', {
    alias: 'widget.pvt-filtering-button',
    extend: 'SA.view.MenuButton',

    cls: 'sa-pvt-filtering-button',
    text: 'Filtering',

    setIndicatorVisible(bool) {
        this.ifCls(bool, 'sa-pvt-filtering-button-on');
    },

    showMenu() {
        var menu = this.getMenu();

        menu.show();
        menu.syncPosition();
    }
});